<template>
	<div class="multipleParames">
		<div v-for="(item, index) in tableData.bind" :key="index">
			<span
				v-for="(url, id) in [...(scope.row[item.text] || [])].slice(0, item.length)"
				:key="id"
				:class="item.tit ? item.tit : 'other'"
				>{{
					(item.tip || '') + url + (item.separate == ' | ' && id == 2 ? '' : item.separate || '')
				}}</span
			>
		</div>
	</div>
</template>
<script>
export default {
	name: 'multipleParames',
	props: ['tableData', 'scope'],
};
</script>
<style lang="scss">
.multipleParames {
	.tit {
		color: #409eff;
	}
}
</style>
